import styled, { css } from "styled-components";

export const DivFlex = styled.div`
    display: flex;
    width: 100%;
`;

export const DivAlignCenterWithOverflow = styled.div`
    display: flex;
    align-items: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

const OverflowSpanBold = styled.span`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-weight: bold;
`;

export const OverflowSpan = styled.span`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

interface IIndicatorsPanelHeader{
    currentPeriod?: boolean;
}

export const IndicatorsPanelHeader = styled.div<IIndicatorsPanelHeader>`
    width: 72px;
    min-width: 72px;
	display: flex;
	align-items: center;
	justify-content: center;

    user-select: none;

    margin: 0 4px;
	padding: 0;

    ${(props) => props.currentPeriod && `
        font-weight: bold;
    `}

    @media print{
        width: 48px;
        min-width: 48px;
        opacity: 1;
        align-items: center;
	    justify-content: flex-start;
        margin: 0 2px;
    }
`;

interface ICardIndicatorPanel{
    hasValue: boolean;
    notHover?: boolean;
    currentPeriod?: boolean;
}

export const CardIndicatorPanel = styled.span<ICardIndicatorPanel>`
    width: 72px;
    min-width: 72px;
	display: flex;
	align-items: center;
	justify-content: center;

    position: relative;

	color: var(--default-color-font);
	/* background-color: ${(props) => props.color}; */

	margin: 0 4px;
	padding: 0;

    user-select: none;

	border-radius: 4px;
    transition: 100ms ease;

    >span{
        z-index: 1;
        font-size: 0.7rem;
    }

    ${(props) => !props.hasValue && `
        opacity: 0.4;
    `}

    ${(props) => props.currentPeriod && `
        box-shadow: 0 0 0 2px var(--yellow-soft);
        border: 2px solid var(--yellow-soft);
        background-color: var(--yellow-soft);
        color: #000;
        margin: 0;
        padding: 0;
        font-weight: bold;
    `}

    @media print{
        width: 48px;
        min-width: 48px;
        opacity: 1;
        align-items: center;
	    justify-content: flex-start;
        margin: 0 2px;
    }
`;

export const ArrowLeft = styled.div`
    display: flex;
	align-items: center;
	position: absolute;
	left: -10px;
	z-index: 2;

    user-select: none;
    
    transition: 200ms ease;

    &:hover{
        transform: scale(1.5);
        opacity: 1;
    }
`;

export const ArrowRight = styled.div`
    display: flex;
	align-items: center;
	position: absolute;
	right: -10px;
	z-index: 2;

    user-select: none;

    transition: 200ms ease;

    &:hover{
        transform: scale(1.5);
        opacity: 1;
    }
`;

interface IDivValues{
    borderRight?: boolean;
    wrapInPrint?: boolean;
}

export const DivValues = styled.div<IDivValues>`
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow-x: hidden; 
    overflow-y: hidden; 
    position: relative;

    transition: 200ms ease;

    .arrowLeft-indicators,
    .arrowRight-indicators{
        display: flex;
        opacity: 0.25;
    }

    &:hover{
        .arrowLeft-indicators,
        .arrowRight-indicators{
            display: flex;
            opacity: 0.5;
            cursor: pointer;
        }
    }

    @media(max-width: 599px){
        .arrowLeft-indicators,
        .arrowRight-indicators{
            display: flex;
            opacity: 0.75;
            cursor: pointer;
        }
    }

    border: none;
    ${(props) => props.borderRight && `
        border-right: 1px solid var(--border-color);
        @media(max-width: 960px){
            border-right: none;
        }
    `}

    ${(props) => props.wrapInPrint && `
        @media print{
            >div{
                flex-wrap: wrap !important;
	            justify-content: flex-start !important;
            }
        }
    `}
`;


export const PrintStylesAccumulatedValues = css`
    @media print{
        @page {
            size: landscape;
            margin: 1mm;
            body{
                background-color: #FFF;
                color: #474555 !important;
            }
        }
       
        .noPrintElement{
            display: none !important;
        }

        .printIndicatorsChartAccumulated{
            height: 400px !important;
            width: calc(30%) !important;
        }

        .printIndicatorsChart{
            height: 400px !important;
            flex: 1;
        }
        .printIndicatorsTable{
            margin-top: 8px;
            svg{
                display: none;
            }
        }
        .recharts-layer{
            font-weight: 100 !important;
        }
        .recharts-responsive-container,
        .recharts-wrapper,
        .recharts-surface,
        .recharts-legend-wrapper{
            width: calc(100%) !important;
        }
        .recharts-legend-item > svg{
            width: auto!important;
            display: inline-block!important;
            right:inherit!important; /* align to left */
        }
        .period {
            color: #000 !important;
        }
        .current-period{
            box-shadow: unset !important;
            border: unset !important;
            background-color: unset !important;
            font-weight: bold !important;
            color: #000 !important;
        }
        .container-chart-indicator{
            min-height: calc(100vh - 24px) !important;
            border: none !important;
        }
    }
`;

export default OverflowSpanBold;
